const SeverityWarningLight = ({ width = "17", height = "16" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.14453 0C3.72625 0 0.144531 3.58172 0.144531 8C0.144531 12.4183 3.72625 16 8.14453 16C12.5628 16 16.1445 12.4183 16.1445 8C16.1445 5.87827 15.3017 3.84344 13.8014 2.34315C12.3011 0.842855 10.2663 0 8.14453 0ZM8.14453 12C7.7027 12 7.34453 11.6418 7.34453 11.2C7.34453 10.7582 7.7027 10.4 8.14453 10.4C8.58636 10.4 8.94453 10.7582 8.94453 11.2C8.94453 11.6418 8.58636 12 8.14453 12ZM8.14453 9.6C8.58636 9.6 8.94453 9.24183 8.94453 8.8V4.8C8.94453 4.35817 8.58636 4 8.14453 4C7.7027 4 7.34453 4.35817 7.34453 4.8V8.8C7.34453 9.24183 7.7027 9.6 8.14453 9.6Z"
      fill="#FCD570"
    />
  </svg>
);

export default SeverityWarningLight;
